/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Virtuoso } from 'react-virtuoso';

export const MyVirtuoso = styled(Virtuoso)`
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Palette.PrimaryGray._300};
    border-radius: 8px;
  }

  min-width: 375px;
  border-right: 1px solid ${Palette.PrimaryGray._200};
`;
